import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import Link from 'components/Link';
import { content as ContentPropType } from 'lib/CustomPropTypes';

const Author = ({ card: { computedValues, id, item } }) => {
  const defaultAuthorPhotoUrl = 'https://media1.s-nbcnews.com/i/newscms/2020_33/3403770/fallback_author_image-centered_2c5d5b248b0cc9c6b1ee438ca438f9ec.png';

  const headlineText = get(computedValues, 'headline', '');
  const articlePageUrl = get(computedValues, 'url', undefined);

  const author = get(item, ['authors', 0, 'person'], {});
  const authorName = get(author, 'name', '');
  const authorPageUrl = get(author, ['url', 'primary'], '');
  const authorPhotoUrl = get(author, ['primaryImage', 'url', 'primary'], defaultAuthorPhotoUrl);

  return (
    <div
      className="bacon-cards-author"
      data-test="bacon-cards-author__container"
      data-contentid={id}
    >
      {authorPhotoUrl && (
        <div className="bacon-cards-author__photo-group">
          {authorPageUrl ? (
            <Link
              to={authorPageUrl}
              className="bacon-cards-author__photo__link"
              data-test="bacon-cards-author__photo__link"
            >
              <img src={authorPhotoUrl} alt={authorName} className="bacon-cards-author__photo" />
            </Link>
          ) : (
            <img src={authorPhotoUrl} alt={authorName} className="bacon-cards-author__photo" />
          )}
        </div>
      )}
      <div className="bacon-cards-author__text-group">
        {
          authorPageUrl ? (
            <Link
              to={authorPageUrl}
              className="bacon-cards-author__photo__link"
              data-test="bacon-cards-author__photo__link"
            >
              <span
                className="bacon-cards-author__name"
                data-test="bacon-cards-author__name"
              >
                {authorName}
              </span>
            </Link>
          ) : (
            <span
              className="bacon-cards-author__name"
              data-test="bacon-cards-author__name"
            >
              {authorName}
            </span>
          )
        }
        <div
          className="bacon-cards-author__headline"
          data-test="bacon-cards-author__headline"
        >
          {articlePageUrl ? (
            <Link
              to={articlePageUrl}
              className="bacon-cards-article__link"
              data-test="bacon-cards-article__link"
            >
              {headlineText}
            </Link>
          ) : (
            headlineText
          )}
        </div>
      </div>
    </div>
  );
};

Author.contextTypes = {
  vertical: PropTypes.string,
};

Author.propTypes = {
  card: ContentPropType,
};

Author.defaultProps = {
  card: {},
};

export { Author };
